import { PatientLabResultControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useUserArchiveResult = () =>
  useMutationWithLoading(
    async (params: {
      patientLabResultId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientLabResultControllerApi(
        getConfigObject()
      ).updatePatientLabResultArchiveStatus(
        params?.patientLabResultId,
        params?.status,
        params?.xTENANTID
      )
  );
